import { Box, Button, Paper, Table, TableContainer, TableHead, TableBody, TableCell, TableRow } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";

const infoTableCellSx = {
  fontSize: 17
};

export const UserTable = ({ userList, onClickEditButton, onClickDeleteButton }) => {
  const columns = ["No.", "氏名", "フリガナ", "種別", "取引先", "店舗", ""];
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            {columns.map((columnName, i) => (
              <TableCell
                key={`${columnName}_${i}`}
                sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
              >
                {columnName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {userList
            .map((data, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: blueGrey[50],
                  },
                }}
              >
              <TableCell sx={{ ...infoTableCellSx, width: '3%', textAlign: 'right' }}>{data.no}</TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '15%' }}>{data.name}</TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '20%' }}>{data.kana}</TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '8%' }}>{data.type}</TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '12%' }}>{data.customer}</TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '12%' }}>
                {data.type === "取引先" && (!data.shop || data.shop.trim() === "") ? "本店" : data.shop}
              </TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '11%' }}>
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="outlined"
                    sx={{ marginRight: 3 }}
                    onClick={onClickEditButton(data.userId)}
                  >
                    編集
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={onClickDeleteButton(data.userId, data.name)}
                  >
                    削除
                  </Button>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
